import React from 'react';
import { Text } from '@moda/om';
import { ReturnPolicy } from '../../generated/types/globalTypes';
import { ReturnPolicyCopy } from './ReturnPolicyCopy';

interface Props {
  returnPolicy: ReturnPolicy;
  promoCodeApplied: boolean;
}

export const LineItemReturnPolicyText: React.FC<Props> = props => (
  <Text className="LineItemReturnPolicyText">
    <ReturnPolicyCopy {...props} highlightDaysNumber />
  </Text>
);
